/**
 * Product Builder — AI Image field (native type, settings-driven)
 */
(function () {
  'use strict';

  function runModule() {
    if (window._pbAiImageModuleLoaded) return true;
    var PB = window.productBuilder;
    if (!PB) return false;
    window._pbAiImageModuleLoaded = true;

  /**
   * productBuilder.parseSettings() only keeps generic keys (required, min, accept…)
   * and drops AI fields. Shopify metaobject settings may be plain multi-line "key: value"
   * text or a JSON object — parse all keys needed for generate-character.
   */
  function parseAiSettings(raw) {
    var out = {};
    if (raw == null) return out;

    if (typeof raw === 'object' && !Array.isArray(raw)) {
      var merged = {};
      if (typeof raw.value === 'string' && raw.value.trim()) {
        merged = parseAiSettings(raw.value);
      }
      Object.keys(raw).forEach(function (k) {
        if (k === 'value') return;
        var v = raw[k];
        if (v != null && typeof v !== 'object') merged[k] = v;
      });
      if (PB.parseSettings) {
        var ps = PB.parseSettings(raw);
        if (ps && ps.required !== undefined) merged.required = ps.required;
      }
      return merged;
    }

    var s = String(raw).trim();
    if (!s) return out;
    if (s.charAt(0) === '{') {
      try {
        var j = JSON.parse(s);
        if (j && typeof j === 'object') return parseAiSettings(j);
      } catch (e) {}
    }

    s.split(/\r?\n/).forEach(function (line) {
      line = line.trim();
      if (!line) return;
      var idx = line.indexOf(':');
      if (idx === -1) return;
      var key = line.slice(0, idx).trim().replace(/\s+/g, '_');
      var val = line.slice(idx + 1).trim();
      if (key) out[key] = val;
    });

    if (PB.parseSettings) {
      var ps2 = PB.parseSettings(raw);
      if (ps2 && ps2.required !== undefined) out.required = ps2.required;
    }
    return out;
  }

  function parseCfg(raw) {
    return parseAiSettings(raw);
  }

  function photoProperty(label, cfg) {
    var p = cfg.photo_property || cfg.photoProperty;
    return (p && String(p).trim()) || 'Photo';
  }

  function characterProperty(label, cfg) {
    var p = cfg.character_property || cfg.characterProperty;
    return (p && String(p).trim()) || String(label || '').trim() || 'Character';
  }

  var SESSION_GENERATION_CAP = 20;
  var LOADER_MSG_GENERATE = 'Creating your character… This can take a few seconds.';
  var LOADER_MSG_REVISE = 'Applying your edit… This can take a few seconds.';
  var CAP_STATUS_MSG =
    'You\u2019ve reached the max edits for this session. Tap Continue or contact us for help.';
  function sessionGenerationCap() {
    return SESSION_GENERATION_CAP;
  }

  function sessionCapHit(state) {
    return (state.generationCount || 0) >= sessionGenerationCap();
  }

  function getEndpoint() {
    var d = window.BUILDER_DATA || {};
    return (d.mediaApiEndpoint || '').replace(/\/$/, '');
  }

  function callMediaApi(action, payload) {
    var endpoint = getEndpoint();
    if (!endpoint) return Promise.reject(new Error('Media API not configured'));
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, action === 'create-character-job' ? 60000 : 25000);
    return fetch(endpoint, {
      method: 'POST', signal: controller.signal,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: action, payload: payload })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (json) {
        if (!res.ok) {
          var error = new Error(json.error || 'Unable to check your image right now. Your photo is saved.');
          error.status = res.status;
          throw error;
        }
        return json;
      });
    }).finally(function () { clearTimeout(timer); });
  }

  function stopPoll(state) {
    if (!state) return;
    if (state._pollJobId && window.PBAiJobCoordinator && window.PBAiJobCoordinator.stopJobPoll) {
      window.PBAiJobCoordinator.stopJobPoll(state._pollJobId);
    }
    state._pollJobId = '';
    if (state._pollTimer) {
      clearTimeout(state._pollTimer);
      state._pollTimer = null;
    }
  }

  function dispatchJobUpdated(wrap, state) {
    try {
      var bs = window.builderState;
      var pb = window.productBuilder;
      if (bs) {
        if (
          bs.mode === 'SUB' &&
          bs.sub &&
          bs.sub.isQueueItem &&
          window.PBBundleRowEncode &&
          typeof window.PBBundleRowEncode.persistRowAiImageDraftToState === 'function'
        ) {
          window.PBBundleRowEncode.persistRowAiImageDraftToState(bs, { pb: pb });
        } else if (
          window.PBFlushEncode &&
          typeof window.PBFlushEncode.persistMainAiImageDraftToState === 'function'
        ) {
          window.PBFlushEncode.persistMainAiImageDraftToState('#main-flow-container', {
            builderState: bs,
          });
        }
        var status = state && state.jobStatus ? state.jobStatus : 'idle';
        /* PB-AOG-3 — doorway opens on success: promote Character onto main-flow sync source immediately (offer-open belt reads this). */
        if (
          status === 'succeeded' &&
          pb &&
          !(bs.mode === 'SUB' && bs.sub && bs.sub.isQueueItem) &&
          typeof pb.normalizeMainAiImageSelections === 'function'
        ) {
          var mainProduct = window.BUILDER_DATA && window.BUILDER_DATA.mainProduct;
          if (mainProduct) pb.normalizeMainAiImageSelections(mainProduct);
        }
        if (
          (status === 'succeeded' || status === 'failed') &&
          window.PBBundleRowEncode &&
          typeof window.PBBundleRowEncode.projectAiMediaAfterJobTerminal === 'function'
        ) {
          window.PBBundleRowEncode.projectAiMediaAfterJobTerminal({
            builderState: bs,
            pb: pb,
            jobStatus: status,
            wrap: wrap,
            state: state,
          });
        }
      }
    } catch (persistErr) {}
    try {
      var terminalStatus = state && state.jobStatus ? state.jobStatus : 'idle';
      if (
        (terminalStatus === 'succeeded' || terminalStatus === 'failed') &&
        pb &&
        typeof pb.refreshAiReviewChrome === 'function'
      ) {
        pb.refreshAiReviewChrome();
      }
    } catch (refreshErr) {}
    try {
      document.dispatchEvent(
        new CustomEvent('pb-ai-job-updated', {
          bubbles: true,
          detail: {
            wrap: wrap,
            label: wrap && wrap.dataset ? wrap.dataset.label : '',
            jobStatus: state.jobStatus || 'idle',
            jobId: state.jobId || ''
          }
        })
      );
    } catch (e) {}
  }

  function dispatchJobStarted(wrap, detail) {
    try {
      document.dispatchEvent(
        new CustomEvent('pb-ai-job-started', {
          bubbles: true,
          detail: Object.assign({ wrap: wrap, label: wrap && wrap.dataset ? wrap.dataset.label : '' }, detail || {})
        })
      );
    } catch (e) {}
  }

  function resolveFieldReadiness(wrap, state) {
    if (window.PBFieldAiImage && typeof window.PBFieldAiImage.getFieldReadiness === 'function') {
      return window.PBFieldAiImage.getFieldReadiness(wrap);
    }
    var cfg = parseCfg(wrap.dataset.settings || '');
    var inner = getInnerUploadWrap(wrap);
    var hidden = inner ? inner.querySelector('input.builder-required[data-label]') : null;
    var required = !!(cfg.required === true || cfg.required === 'true');
    var hasPhoto =
      (hidden && hidden.dataset.valid === 'true') || !!(state.photoUrl && String(state.photoUrl).trim());
    var jobStatus = state.jobStatus || 'idle';
    var running = state.isGenerating || jobStatus === 'queued' || jobStatus === 'running';
    var hasCharacter = (state.characterUrls || []).length > 0;
    var failed = jobStatus === 'failed' || !!state.aiError;
    var reviewAcknowledged =
      window.PBAiReviewHop &&
      typeof window.PBAiReviewHop.isReviewAcknowledged === 'function' &&
      window.PBAiReviewHop.isReviewAcknowledged(window.builderState, wrap.dataset?.label);
    var characterReady =
      required && hasCharacter && !running && jobStatus === 'succeeded' && !failed;
    return {
      stepNavigable: required ? hasPhoto : true,
      finalizeReady: required ? !!(characterReady && reviewAcknowledged) : true,
      jobStatus: jobStatus,
      characterReady: characterReady,
      required: required,
    };
  }

  function setJobStatus(wrap, state, status) {
    state.jobStatus = status || 'idle';
    dispatchJobUpdated(wrap, state);
    if (PB.checkStepValidity) PB.checkStepValidity();
  }

  function shouldApplyGenerationResult(state, rid, bodyJobId) {
    var bid = bodyJobId != null ? String(bodyJobId).trim() : '';
    var sid = state && state.jobId ? String(state.jobId).trim() : '';
    if (bid && sid && bid === sid) return true;
    return rid === state.requestId;
  }

  function isActiveAiJobState(state) {
    if (!state) return false;
    if (state.isGenerating) return true;
    var status = state.jobStatus || 'idle';
    return status === 'queued' || status === 'running';
  }

  function reconcileAiJobState(wrap, state) {
    if (!state) return;
    var status = state.jobStatus || 'idle';
    if (state.isGenerating && isTerminalJobStatus(status)) {
      state.jobStatus = 'running';
      status = state.jobStatus;
    } else if (isTerminalJobStatus(status) && state.isGenerating) {
      state.isGenerating = false;
    }
    if (
      status === 'succeeded' &&
      !(state.characterUrls || []).length &&
      wrap &&
      !isActiveAiJobState(state) &&
      !state._pbPendingNewGeneration
    ) {
      var label = wrap.dataset ? wrap.dataset.label : '';
      var cfg = parseCfg(wrap.dataset.settings || '');
      var ck = characterProperty(label, cfg);
      var ctx = PB.getActiveContext ? PB.getActiveContext() : null;
      var recovered = recoverCharacterUrlsFromDom(wrap, state, ctx, ck, label);
      if (recovered.length) {
        state.characterUrls = recovered.slice();
        state.selectedIndex = Math.max(0, Math.min(state.selectedIndex || 0, recovered.length - 1));
        state.isGenerating = false;
      }
    }
  }

  function applyJobPollResult(wrap, state, body, regenIdx, isRevision) {
    var bodyJobId = body && body.jobId != null ? String(body.jobId).trim() : '';
    if (bodyJobId && state.jobId && bodyJobId !== String(state.jobId)) return 'stale';
    var status = body && body.status ? body.status : '';
    if (status === 'queued' || status === 'running') {
      setJobStatus(wrap, state, status);
      return 'pending';
    }
    if (status === 'succeeded') {
      var charUrl = body.characterUrl || body.character_url || '';
      if (!charUrl) {
        applyGenerationFailure(wrap, state, state.requestId, new Error('No image returned'), bodyJobId);
        return 'terminal';
      }
      state.jobId = body.jobId || state.jobId || '';
      applyGenerationSuccess(wrap, state, state.requestId, charUrl, regenIdx, isRevision, bodyJobId);
      return 'terminal';
    }
    if (status === 'failed') {
      var errMsg = (body && body.error) ? body.error : 'Generation failed';
      state.jobId = body.jobId || state.jobId || '';
      applyGenerationFailure(wrap, state, state.requestId, new Error(errMsg), bodyJobId);
      return 'terminal';
    }
    return 'pending';
  }

  function isTerminalJobStatus(status) {
    return status === 'succeeded' || status === 'failed';
  }

  function resumeInFlightJob(wrap, state) {
    var jobId = (state.jobId || '').trim();
    var status = state.jobStatus || 'idle';
    if (!jobId || isTerminalJobStatus(status)) return;

    stopPoll(state);
    state.isGenerating = true;
    state.aiError = '';
    updatePreview(wrap, state);
    dispatchJobUpdated(wrap, state);
    var pending = state.pendingRequest;
    scheduleJobPoll(wrap, state, jobId, state.requestId, pending ? pending.regenIdx : state.generationCount || 0, !!(pending && pending.isRevision), 0);
  }

  function syncInFlightJob(wrap) {
    if (!wrap) return;
    var state = ensureState(wrap);
    reconcileAiJobState(wrap, state);
    var jobId = (state.jobId || '').trim();
    if (!jobId) return;

    if (state.jobStatus === 'succeeded' && !(state.characterUrls || []).length) {
      callMediaApi('get-character-job', { jobId: jobId })
        .then(function (body) {
          applyJobPollResult(wrap, state, body, state.generationCount || 0, false);
          updatePreview(wrap, state);
          syncSelections(wrap, state);
          dispatchJobUpdated(wrap, state);
        })
        .catch(function () {});
      return;
    }

    if (isTerminalJobStatus(state.jobStatus || 'idle')) return;
    if (!state.isGenerating) {
      state.isGenerating = true;
      updatePreview(wrap, state);
      dispatchJobUpdated(wrap, state);
    }
    resumeInFlightJob(wrap, state);
    if (window.PBAiJobCoordinator && typeof window.PBAiJobCoordinator.pollJobNow === 'function') {
      window.PBAiJobCoordinator.pollJobNow(jobId);
    }
  }

  function isJobPollActive(state, jobId) {
    if (!state || !jobId) return false;
    if (String(state.jobId || '').trim() !== String(jobId).trim()) return false;
    return !isTerminalJobStatus(state.jobStatus || 'idle');
  }

  function scheduleJobPoll(wrap, state, jobId, rid, regenIdx, isRevision, attempt) {
    stopPoll(state);
    state._pollJobId = jobId;
    var coordinator = window.PBAiJobCoordinator;
    if (!coordinator || typeof coordinator.startJobPoll !== 'function') {
      applyGenerationFailure(
        wrap,
        state,
        rid,
        new Error('AI job coordinator not loaded. Refresh the page and try again.')
      );
      return;
    }
    coordinator.startJobPoll({
      jobId: jobId,
      attempt: attempt || 0,
      immediate: true,
      isActive: function () {
        return isJobPollActive(state, jobId);
      },
      callMediaApi: callMediaApi,
      onResult: function (body) {
        return applyJobPollResult(wrap, state, body, regenIdx, isRevision);
      },
      onError: function (err) {
        applyGenerationFailure(wrap, state, state.requestId, err);
      },
      onTimeout: function () {
        applyGenerationFailure(
          wrap,
          state,
          state.requestId,
          new Error('Your image is taking longer than usual. Your photo is saved. Tap Check status to reconnect.')
        );
      },
    });
  }

  function buildGenerationFingerprint(wrap, photoUrl, cfg, regenIdx) {
    var coordinator = window.PBAiJobCoordinator;
    var ref = cfg.reference_image_url || cfg.referenceImageUrl || cfg.reference_url || '';
    var label = wrap && wrap.dataset ? wrap.dataset.label || '' : '';
    if (coordinator && typeof coordinator.buildGenerationFingerprint === 'function') {
      return coordinator.buildGenerationFingerprint(label, photoUrl, ref, regenIdx);
    }
    return [label, photoUrl || '', ref, String(regenIdx || 0)].join('|');
  }

  function isActiveJobStatus(status) {
    return status === 'queued' || status === 'running';
  }

  function resumeExistingInFlightJob(wrap, state, jobId, regenIdx, isRevision) {
    state.jobId = jobId;
    state.isGenerating = true;
    state.aiError = '';
    if (!isActiveJobStatus(state.jobStatus)) state.jobStatus = 'queued';
    updatePreview(wrap, state);
    dispatchJobUpdated(wrap, state);
    scheduleJobPoll(wrap, state, jobId, state.requestId, regenIdx, isRevision, 0);
    return Promise.resolve('pending');
  }

  function startCharacterJob(wrap, state, payload, regenIdx, isRevision, opts) {
    opts = opts || {};
    var cfg = parseCfg(wrap.dataset.settings || '');
    var fingerprint = buildGenerationFingerprint(wrap, payload.photo, cfg, regenIdx) + '|' + JSON.stringify(payload);
    var coordinator = window.PBAiJobCoordinator;

    if (
      state.inFlightFingerprint === fingerprint &&
      state.jobId &&
      isActiveJobStatus(state.jobStatus) &&
      state.isGenerating
    ) {
      return resumeExistingInFlightJob(wrap, state, state.jobId, regenIdx, isRevision);
    }

    if (coordinator && typeof coordinator.getInFlightCreateJobId === 'function') {
      var sharedJobId = coordinator.getInFlightCreateJobId(fingerprint);
      if (sharedJobId) {
        state.inFlightFingerprint = fingerprint;
        return resumeExistingInFlightJob(wrap, state, sharedJobId, regenIdx, isRevision);
      }
    }

    stopPoll(state);
    state.isGenerating = true;
    state.aiError = '';
    state.jobStatus = 'queued';
    state.jobId = '';
    state.pendingRequest = { payload: payload, regenIdx: regenIdx, isRevision: !!isRevision };
    state._pbPendingNewGeneration = !isRevision;
    state.reviewPendingFrom = '';
    if (!isRevision) {
      state.characterUrls = [];
      state.selectedIndex = 0;
    }
    state.inFlightFingerprint = fingerprint;
    state.requestId += 1;
    var label = wrap.dataset ? wrap.dataset.label : '';
    if (
      label &&
      window.PBAiReviewHop &&
      typeof window.PBAiReviewHop.clearReviewAcknowledgement === 'function'
    ) {
      window.PBAiReviewHop.clearReviewAcknowledgement(window.builderState, label);
    }
    var rid = state.requestId;
    var els = getPreviewEls(wrap);
    if (els.loaderMsg) {
      els.loaderMsg.textContent = isRevision ? LOADER_MSG_REVISE : LOADER_MSG_GENERATE;
    }
    updatePreview(wrap, state);
    dispatchJobUpdated(wrap, state);

    function handleCreateBody(body) {
      if (rid !== state.requestId) return;
      var jobId = body && body.jobId ? body.jobId : '';
      state.jobId = jobId;
      var status = body && body.status ? body.status : 'queued';
      if (status === 'succeeded' || status === 'failed') {
        var outcome = applyJobPollResult(wrap, state, body, regenIdx, isRevision);
        if (!opts.skipAutoAdvance) dispatchJobStarted(wrap, { cached: !!body.cached });
        return outcome;
      }
      setJobStatus(wrap, state, status);
      if (!opts.skipAutoAdvance) dispatchJobStarted(wrap, { cached: !!body.cached });
      if (jobId) scheduleJobPoll(wrap, state, jobId, rid, regenIdx, isRevision, 0);
      return 'pending';
    }

    function runCreate() {
      return callMediaApi('create-character-job', payload);
    }

    var createPromise;
    if (coordinator && typeof coordinator.acquireCharacterJobCreate === 'function') {
      createPromise = coordinator.acquireCharacterJobCreate(fingerprint, runCreate);
    } else {
      createPromise = runCreate();
    }

    return createPromise.then(handleCreateBody).catch(function (err) {
      applyGenerationFailure(wrap, state, rid, err);
    });
  }

  function getImgPage(wrap) {
    var step = wrap.closest('.pb-step');
    if (!step || !step.id) return null;
    var imgId = step.id.replace('content-page-', 'img-page-').replace('sub-content-page-', 'sub-img-page-');
    return document.getElementById(imgId);
  }

  function getPreviewEls(wrap) {
    var page = getImgPage(wrap);
    if (!page) {
      return {
        img: null,
        placeholder: null,
        loader: null,
        loaderMsg: null,
        error: null,
        reviseBar: null,
        reviseInput: null,
        reviseSend: null,
        cancelBtn: null
      };
    }
    return {
      img: page.querySelector('.pb-ai-image-preview-img'),
      placeholder: page.querySelector('.pb-ai-image-preview-placeholder'),
      loader: page.querySelector('.pb-ai-image-preview-loader'),
      loaderMsg: page.querySelector('.pb-ai-image-preview-loader-msg'),
      error: page.querySelector('.pb-ai-image-preview-error'),
      reviseBar: page.querySelector('.pb-ai-image-revise-bar'),
      reviseInput: page.querySelector('.pb-ai-image-revise-input'),
      reviseSend: page.querySelector('.pb-ai-image-revise-send'),
      cancelBtn: page.querySelector('.pb-ai-image-cancel-btn')
    };
  }

  function getInnerUploadWrap(wrap) {
    return wrap.querySelector('.pb-upload-wrap');
  }

  function getUploadUrls(inner) {
    if (!inner || !PB.getUploadUrls) return [];
    return PB.getUploadUrls(inner) || [];
  }

  function isRecoverableCharacterUrl(url) {
    if (typeof url !== 'string' || !url.trim()) return false;
    var u = url.trim();
    if (u.indexOf('http://') === 0 || u.indexOf('https://') === 0 || u.indexOf('//') === 0) return true;
    if (u.indexOf('/generated/') !== -1) return true;
    return false;
  }

  function recoverCharacterUrlsFromDom(wrap, state, ctx, ck, label) {
    var urls = (state && state.characterUrls) || [];
    if (urls.length) return urls.filter(isRecoverableCharacterUrl).map(function (u) { return String(u).trim(); });

    var els = getPreviewEls(wrap);
    if (els.img && els.img.src) {
      var imgSrc = String(els.img.src).trim();
      if (isRecoverableCharacterUrl(imgSrc) && imgSrc.indexOf('data:') !== 0 && imgSrc.indexOf('blob:') !== 0) {
        return [imgSrc];
      }
    }

    if (ctx && ctx.selections) {
      var nested = ctx.selections[label];
      if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
        var fromNested = nested[ck];
        if (isRecoverableCharacterUrl(fromNested)) return [String(fromNested).trim()];
        var keys = Object.keys(nested);
        for (var ni = 0; ni < keys.length; ni += 1) {
          var nv = nested[keys[ni]];
          if (!isRecoverableCharacterUrl(nv)) continue;
          if (PB.isLikelyAiCharacterUrl && PB.isLikelyAiCharacterUrl(nv)) return [String(nv).trim()];
          if (String(keys[ni]).toLowerCase().indexOf('character') !== -1) return [String(nv).trim()];
        }
      }
      var flat = ctx.selections[ck];
      if (isRecoverableCharacterUrl(flat)) return [String(flat).trim()];
      if (isRecoverableCharacterUrl(ctx.selections.Character)) {
        return [String(ctx.selections.Character).trim()];
      }
    }
    return [];
  }

  function syncSelections(wrap, state) {
    var label = wrap.dataset.label;
    if (!label) return;
    var cfg = parseCfg(wrap.dataset.settings || '');
    var pk = photoProperty(label, cfg);
    var ck = characterProperty(label, cfg);
    var ctx = PB.getActiveContext ? PB.getActiveContext() : null;
    if (!ctx || !ctx.selections) return;

    var innerUpload = getInnerUploadWrap(wrap);
    var uploadUrls = getUploadUrls(innerUpload);
    var photoUrl = '';
    // Upload widget hidden input is the source of truth (state.photoUrl can stay stale after cart rehydrate).
    if (uploadUrls && uploadUrls[0]) {
      photoUrl = uploadUrls[0];
      state.photoUrl = photoUrl;
    } else if (state.photoUrl) {
      photoUrl = state.photoUrl;
    } else if (ctx.selections[label] && typeof ctx.selections[label] === 'object' && !Array.isArray(ctx.selections[label])) {
      var prev = ctx.selections[label][pk];
      if (prev) photoUrl = prev;
    }
    var urls = recoverCharacterUrlsFromDom(wrap, state, ctx, ck, label);
    var allowCharacterRecover =
      !isActiveAiJobState(state) && !state._pbPendingNewGeneration;
    if (allowCharacterRecover && urls.length && !(state.characterUrls || []).length) {
      state.characterUrls = urls.slice();
    } else if (isActiveAiJobState(state) || state._pbPendingNewGeneration) {
      urls = state.characterUrls || [];
    }
    var sel = Math.max(0, Math.min(state.selectedIndex || 0, Math.max(urls.length - 1, 0)));
    var charUrl = urls.length ? urls[sel] : '';
    if (isActiveAiJobState(state) || state._pbPendingNewGeneration) {
      charUrl = '';
    }

    var out = {};
    out[pk] = photoUrl;
    out[ck] = charUrl;
    if (state.aiError) out['AI Error'] = state.aiError;
    else if (Object.prototype.hasOwnProperty.call(out, 'AI Error')) delete out['AI Error'];

    ctx.selections[label] = out;
    if (pk && pk !== label) delete ctx.selections[pk];
    if (ck && ck !== label) delete ctx.selections[ck];
    if (PB.syncPersonalizationTemplates) {
      var selRoot = window.builderState && window.builderState.mode === 'MAIN' ? '#main-flow-container' : '#sub-flow-container';
      PB.syncPersonalizationTemplates(selRoot);
    }
    if (PB.checkStepValidity) PB.checkStepValidity();
  }

  function applyPayloadOptions(payload, cfg) {
    var ref = cfg.reference_image_url || cfg.referenceImageUrl || cfg.reference_url;
    if (ref && String(ref).trim()) payload.reference_url = String(ref).trim();
    if (cfg.prompt) payload.prompt = String(cfg.prompt);
    if (cfg.model) payload.model = String(cfg.model);
    if (cfg.aspect_ratio || cfg.aspectRatio) payload.aspectRatio = cfg.aspect_ratio || cfg.aspectRatio;
    if (cfg.image_size || cfg.imageSize) payload.imageSize = cfg.image_size || cfg.imageSize;
    return payload;
  }

  function buildPayload(cfg, photoUrl, regenerateIndex) {
    return applyPayloadOptions(
      {
        photo: photoUrl,
        regenerateIndex: regenerateIndex || 0
      },
      cfg
    );
  }

  function buildRevisionPayload(cfg, photoUrl, revisionOf, revisionPrompt, regenerateIndex) {
    return applyPayloadOptions(
      {
        photo: photoUrl,
        revision_of: revisionOf,
        revision_prompt: revisionPrompt,
        regenerateIndex: regenerateIndex || 0
      },
      cfg
    );
  }

  function readCartMediaUrl(pb, props, keys) {
    if (!props || !keys || !keys.length) return '';
    for (var i = 0; i < keys.length; i++) {
      var cartKey = keys[i];
      if (!cartKey) continue;
      var direct = props[cartKey];
      if (typeof direct === 'string' && (direct.indexOf('http') === 0 || direct.indexOf('//') === 0)) {
        return direct.trim();
      }
      if (pb.readMultiValueProperty) {
        var fromList = pb.readMultiValueProperty(props, cartKey);
        if (fromList && fromList[0] && String(fromList[0]).indexOf('http') === 0) {
          return String(fromList[0]).trim();
        }
      }
    }
    return '';
  }

  function dispatchAiImageSaved() {
    try {
      document.dispatchEvent(new CustomEvent('pb-ai-image-saved', { bubbles: true }));
    } catch (e) {}
  }

  function rehydrateWrap(wrap, data) {
    data = data || {};
    var pUrl = (data.photoUrl || '').trim();
    var characterUrls = Array.isArray(data.characterUrls)
      ? data.characterUrls.filter(function (u) {
          return typeof u === 'string' && u.indexOf('http') === 0;
        })
      : [];
    var cUrl = (data.characterUrl || '').trim();
    if (!characterUrls.length && cUrl) characterUrls = [cUrl];
    var draftJobId = data.jobId != null ? String(data.jobId).trim() : '';
    var draftJobStatus = data.jobStatus != null ? String(data.jobStatus).trim() : '';
    if (!pUrl && !characterUrls.length && !draftJobId) return;

    var inner = getInnerUploadWrap(wrap);
    var hidden = inner && inner.querySelector('input.builder-required[data-label]');
    var state = ensureState(wrap);

    wrap._pbAiRestoring = true;
    try {
      stopPoll(state);
      if (pUrl && inner) {
        if (hidden) {
          hidden.value = JSON.stringify([pUrl]);
          hidden.dataset.valid = 'true';
        }
        if (PB.renderUploadPreviews) PB.renderUploadPreviews(inner, [pUrl], 0);
        state.photoUrl = pUrl;
      }
      if (characterUrls.length) {
        // Restored from draft / cart line / sync belt — already reviewed, never nag.
        state.reviewPendingFrom =
          data.reviewPendingFrom != null ? String(data.reviewPendingFrom).trim() : '';
        state.characterUrls = characterUrls.slice();
        state.selectedIndex =
          typeof data.selectedIndex === 'number'
            ? Math.max(0, Math.min(data.selectedIndex, characterUrls.length - 1))
            : characterUrls.length - 1;
        state.generationCount =
          typeof data.generationCount === 'number'
            ? data.generationCount
            : characterUrls.length;
        state.aiError = '';
        state.jobStatus = 'succeeded';
        state.jobId = draftJobId || state.jobId || '';
        state.isGenerating = false;
      } else if (draftJobId) {
        state.jobId = draftJobId;
        state.jobStatus = draftJobStatus || 'queued';
        state.isGenerating = false;
      }
      state.pendingRequest = data.pendingRequest || null;
      if (state.pendingRequest) {
        state.jobId = draftJobId;
        state.jobStatus = draftJobId ? draftJobStatus || 'queued' : 'failed';
        state.isGenerating = false;
        state.generationCount = Number(data.generationCount) || 0;
        state.aiError = 'Your photo is saved. Tap Retry to reconnect to your request.';
      }
    } finally {
      wrap._pbAiRestoring = false;
    }

    updatePreview(wrap, state);
    syncSelections(wrap, state);

    if (state.jobId && !isTerminalJobStatus(state.jobStatus)) {
      resumeInFlightJob(wrap, state);
    }
  }

  /**
   * PB-AIRS-5 — id for this page load. A character owes a review only when it was
   * generated here; anything restored from draft / cart / sync belt is already reviewed.
   */
  function reviewSessionId() {
    if (window.PBFieldAiImage && typeof window.PBFieldAiImage.getReviewSessionId === 'function') {
      return window.PBFieldAiImage.getReviewSessionId();
    }
    return '';
  }

  function ensureState(wrap) {
    if (!wrap._pbAiState) {
      wrap._pbAiState = {
        reviewPendingFrom: '',
        characterUrls: [],
        selectedIndex: 0,
        generationCount: 0,
        requestId: 0,
        isGenerating: false,
        photoUrl: '',
        aiError: '',
        jobId: '',
        pendingRequest: null,
        jobStatus: 'idle',
        inFlightFingerprint: '',
        _pollJobId: '',
        _pollTimer: null
      };
    }
    return wrap._pbAiState;
  }

  function friendlyError(msg) {
    var s = String(msg || '');
    if (s.indexOf('firebase_api_endpoint') !== -1 || s.indexOf('No firebase_api') !== -1 || s.indexOf('Media API not configured') !== -1) {
      return 'The AI service is not connected for this store yet. Your photo is saved; ask your team to set the Media API URL in Shopify theme settings.';
    }
    if (s.indexOf('Failed to fetch') !== -1 || s.indexOf('NetworkError') !== -1 || s.indexOf('Load failed') !== -1) {
      return 'Could not reach the AI service. Check your internet connection and try again.';
    }
    if (s.indexOf('not supported for AI') !== -1 || s.indexOf('File type not supported') !== -1) {
      return 'This photo format is not supported for AI. Please upload a JPG or PNG (iPhone: Settings > Camera > Formats > Most Compatible).';
    }
    return s || 'Something went wrong. Try again or use another photo.';
  }

  function updateFieldStatus(wrap, state) {
    var el = wrap.querySelector('.pb-ai-image-field-status');
    if (!el) return;
    var urls = state.characterUrls || [];
    var url = urls.length ? urls[urls.length - 1] : '';
    el.classList.remove('pb-ai-image-field-status--error');
    if (state.isGenerating || state.aiError) {
      el.textContent = '';
      el.style.display = 'none';
      return;
    }
    var text = '';
    if (sessionCapHit(state) && url) {
      text = CAP_STATUS_MSG;
      el.classList.add('pb-ai-image-field-status--error');
    } else if (url) {
      if (state.photoUrl) {
        text =
          'Character ready. Tap Retry for a new version, or describe an edit on the image.';
      } else {
        text =
          'Character art is saved. Add a reference photo above to replace it or generate a new version.';
      }
    } else if (state.photoUrl) {
      text = 'Photo added. If the preview does not update, wait a few seconds or check your connection.';
    }
    if (text) {
      el.textContent = text;
      el.style.display = 'block';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  function updatePreview(wrap, state) {
    var els = getPreviewEls(wrap);
    var cfg = parseCfg(wrap.dataset.settings || '');
    var urls = state.characterUrls || [];
    var sel = Math.max(0, Math.min(state.selectedIndex || 0, urls.length - 1));
    var url = urls.length ? urls[sel] : '';
    var atCap = sessionCapHit(state);

    updateFieldStatus(wrap, state);

    if (els.error) {
      if (state.aiError) {
        els.error.textContent = friendlyError(state.aiError);
        els.error.style.display = 'block';
      } else {
        els.error.textContent = '';
        els.error.style.display = 'none';
      }
    }
    var ctrlErr = wrap.querySelector('.pb-ai-image-error');
    if (ctrlErr) {
      ctrlErr.style.display = 'none';
    }
    if (els.loader) {
      els.loader.style.display = state.isGenerating ? 'flex' : 'none';
    }
    if (els.cancelBtn) {
      els.cancelBtn.style.display = state.isGenerating ? 'inline-flex' : 'none';
    }
    if (els.loaderMsg && !state.isGenerating) {
      els.loaderMsg.textContent = LOADER_MSG_GENERATE;
    }
    if (els.img) {
      var media = els.img.closest('[data-store-ai-media]');
      if (media) media.dataset.mediaActive = url ? 'true' : 'false';
      if (url) {
        var displayUrl = url;
        if (window.pbMediaUpload && typeof window.pbMediaUpload.normalizeMediaUrl === 'function') {
          displayUrl = window.pbMediaUpload.normalizeMediaUrl(url);
        }
        if (media && window.PBStoreMedia) window.PBStoreMedia.syncStoreMedia(media, displayUrl);
        else els.img.src = displayUrl;
        els.img.style.display = 'block';
      } else {
        if (media && window.PBStoreMedia) {
          window.PBStoreMedia.syncStoreMedia(media, '');
          media.dataset.state = 'empty';
          media.querySelector('.store-media-fallback').hidden = true;
        } else els.img.removeAttribute('src');
        els.img.style.display = 'none';
      }
    }
    if (els.placeholder) {
      els.placeholder.style.display =
        url || state.isGenerating || state.photoUrl || state.aiError ? 'none' : 'flex';
    }

    var thumbs = wrap.querySelector('.pb-ai-image-thumbs');
    if (thumbs) {
      thumbs.innerHTML = '';
      urls.forEach(function (u, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pb-ai-image-thumb' + (i === sel ? ' active' : '');
        b.textContent = String(i + 1);
        b.addEventListener('click', function () {
          state.selectedIndex = i;
          updatePreview(wrap, state);
          syncSelections(wrap, state);
          dispatchAiImageSaved();
        });
        thumbs.appendChild(b);
      });
    }

    var showRevise = !!url && !state.isGenerating && !atCap;
    if (media) media.dataset.reviseVisible = showRevise ? 'true' : 'false';
    if (els.reviseBar) {
      els.reviseBar.style.display = showRevise ? 'flex' : 'none';
      els.reviseBar.setAttribute('aria-hidden', showRevise ? 'false' : 'true');
    }
    if (els.reviseInput) {
      els.reviseInput.disabled = !showRevise;
    }
    if (els.reviseSend) {
      els.reviseSend.disabled = !showRevise || !String(els.reviseInput && els.reviseInput.value || '').trim();
    }

    var retry = wrap.querySelector('.pb-ai-image-retry');
    if (retry) {
      var used = state.generationCount || 0;
      retry.style.display = state.photoUrl ? 'inline-block' : 'none';
      retry.disabled = state.isGenerating || !state.photoUrl || atCap;
      retry.textContent = state.jobId && state.jobStatus === 'failed' ? 'Check status' : 'Retry';
    }
  }

  function normalizeCharacterUrl(charUrl) {
    if (window.pbMediaUpload && typeof window.pbMediaUpload.normalizeMediaUrl === 'function') {
      return window.pbMediaUpload.normalizeMediaUrl(charUrl);
    }
    return charUrl;
  }

  function clearInFlightFingerprint(state) {
    if (!state || !state.inFlightFingerprint) return;
    var coordinator = window.PBAiJobCoordinator;
    if (coordinator && typeof coordinator.clearGenerationFingerprint === 'function') {
      coordinator.clearGenerationFingerprint(state.inFlightFingerprint);
    }
    state.inFlightFingerprint = '';
  }

  function applyGenerationSuccess(wrap, state, rid, charUrl, regenIdx, isRevision, bodyJobId) {
    if (!shouldApplyGenerationResult(state, rid, bodyJobId)) return;
    charUrl = normalizeCharacterUrl(charUrl);
    if (!isRevision && regenIdx === 0) state.characterUrls = [];
    state.characterUrls.push(charUrl);
    state.selectedIndex = state.characterUrls.length - 1;
    state.generationCount = isRevision ? (state.generationCount || 0) + 1 : regenIdx + 1;
    state.isGenerating = false;
    state.jobStatus = 'succeeded';
    state.pendingRequest = null;
    // Generated here → owes a review until the customer opens the Character step.
    state.reviewPendingFrom = reviewSessionId();
    state._pbPendingNewGeneration = false;
    clearInFlightFingerprint(state);
    stopPoll(state);
    updatePreview(wrap, state);
    syncSelections(wrap, state);
    dispatchAiImageSaved();
    dispatchJobUpdated(wrap, state);
    if (
      typeof window !== 'undefined' &&
      window.PBAiReviewHop &&
      typeof window.PBAiReviewHop.buildReviewTargetForWrap === 'function' &&
      typeof window.PBAiReviewHop.persistReviewTargetOnDraft === 'function'
    ) {
      var builderState = window.builderState;
      var label = wrap.dataset ? wrap.dataset.label : '';
      if (builderState && label) {
        var reviewTarget = window.PBAiReviewHop.buildReviewTargetForWrap(wrap, builderState, PB);
        if (reviewTarget) {
          state.reviewTarget = reviewTarget;
          window.PBAiReviewHop.persistReviewTargetOnDraft(builderState, label, reviewTarget);
        }
      }
    }
  }

  function applyGenerationFailure(wrap, state, rid, err, bodyJobId) {
    if (!shouldApplyGenerationResult(state, rid, bodyJobId)) return;
    state.isGenerating = false;
    state.jobStatus = 'failed';
    state._pbPendingNewGeneration = false;
    state.aiError = (err && err.message) ? err.message : 'Generation failed';
    clearInFlightFingerprint(state);
    stopPoll(state);
    updatePreview(wrap, state);
    syncSelections(wrap, state);
    dispatchJobUpdated(wrap, state);
  }

  function cancelGeneration(wrap) {
    if (!wrap) return false;
    var state = ensureState(wrap);
    if (!isActiveAiJobState(state)) return false;
    stopPoll(state);
    state.isGenerating = false;
    state.jobStatus = 'cancelled';
    state.aiError = '';
    state._pbPendingNewGeneration = false;
    state.jobId = '';
    state.pendingRequest = null;
    clearInFlightFingerprint(state);
    state.requestId += 1;
    updatePreview(wrap, state);
    syncSelections(wrap, state);
    dispatchJobUpdated(wrap, state);
    return true;
  }

  function doGenerate(wrap, state, photoUrl, regenIdx, opts) {
    var cfg = parseCfg(wrap.dataset.settings || '');
    return startCharacterJob(wrap, state, buildPayload(cfg, photoUrl, regenIdx), regenIdx, false, opts);
  }

  function doRevise(wrap, state, revisionPrompt) {
    var cfg = parseCfg(wrap.dataset.settings || '');
    var urls = state.characterUrls || [];
    var sel = Math.max(0, Math.min(state.selectedIndex || 0, urls.length - 1));
    var revisionOf = urls.length ? urls[sel] : '';
    var prompt = String(revisionPrompt || '').trim().slice(0, 200);
    if (!revisionOf || !prompt || sessionCapHit(state)) return;

    var els = getPreviewEls(wrap);
    return startCharacterJob(
      wrap,
      state,
      buildRevisionPayload(cfg, state.photoUrl, revisionOf, prompt, state.generationCount),
      state.generationCount,
      true,
      { skipAutoAdvance: true }
    ).then(function () {
      if (els.reviseInput) els.reviseInput.value = '';
    });
  }

  function bindReviseControls(wrap) {
    if (wrap.dataset.pbAiReviseBound === 'true') return;
    var els = getPreviewEls(wrap);
    if (!els.reviseSend || !els.reviseInput) return;
    wrap.dataset.pbAiReviseBound = 'true';

    function submitRevise() {
      var st = ensureState(wrap);
      if (st.isGenerating || sessionCapHit(st)) return;
      var prompt = String(els.reviseInput.value || '').trim();
      if (!prompt) return;
      doRevise(wrap, st, prompt);
    }

    els.reviseSend.addEventListener('click', submitRevise);
    els.reviseInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        submitRevise();
      }
    });
    els.reviseInput.addEventListener('input', function () {
      var st = ensureState(wrap);
      updatePreview(wrap, st);
    });
  }

  function onUploadChange(wrap) {
    if (wrap._pbAiRestoring) return;
    var edit = window.builderState && window.builderState.cartEdit;
    if (edit) edit._pbUserTouchedUpload = true;
    var label = wrap.dataset.label || '';
    if (
      window.PBAiReviewHop &&
      typeof window.PBAiReviewHop.clearReviewAcknowledgement === 'function'
    ) {
      window.PBAiReviewHop.clearReviewAcknowledgement(window.builderState, label);
    } else if (window.builderState && window.builderState.aiReviewHop) {
      window.builderState.aiReviewHop.reviewAcknowledged = false;
      if (label) window.builderState.aiReviewHop.fieldLabel = label;
    }
    var inner = getInnerUploadWrap(wrap);
    if (!inner) return;
    var urls = getUploadUrls(inner);
    var state = ensureState(wrap);
    var photoUrl = urls[0] || '';
    state.photoUrl = photoUrl;
    state.characterUrls = [];
    state.selectedIndex = 0;
    state.generationCount = 0;
    state.aiError = '';
    state.jobId = '';
    state.pendingRequest = null;
    state.jobStatus = 'idle';
    state.reviewPendingFrom = '';
    state._pbPendingNewGeneration = true;
    clearInFlightFingerprint(state);
    state.requestId += 1;
    stopPoll(state);

    if (!photoUrl) {
      state._pbPendingNewGeneration = false;
      updatePreview(wrap, state);
      syncSelections(wrap, state);
      dispatchJobUpdated(wrap, state);
      return;
    }

    updatePreview(wrap, state);
    syncSelections(wrap, state);
    doGenerate(wrap, state, photoUrl, 0, { skipAutoAdvance: false });
  }

  function initWrap(wrap) {
    if (wrap.dataset.pbAiInit === 'true' && typeof wrap._pbAiOnUpload === 'function') return;
    if (wrap.dataset.pbAiInit === 'true' && typeof wrap._pbAiOnUpload !== 'function') {
      wrap.removeAttribute('data-pb-ai-init');
    }

    var label = wrap.dataset.label || '';
    var cfg = parseCfg(wrap.dataset.settings || '');
    var inner = getInnerUploadWrap(wrap);
    if (!inner) return;
    wrap.dataset.pbAiInit = 'true';

    var hidden = inner.querySelector('input.builder-required[data-label]');
    if (hidden) {
      var req = !!cfg.required;
      hidden.dataset.required = req ? 'true' : 'false';
    }

    wrap._pbAiOnUpload = function () {
      onUploadChange(wrap);
    };

    var ctx = PB.getActiveContext ? PB.getActiveContext() : null;
    if (ctx && ctx.selections && label) {
      var existing = ctx.selections[label];
      if (existing && typeof existing === 'string' && existing.trim()) {
        var pkScalar = photoProperty(label, cfg);
        existing = {};
        existing[pkScalar] = ctx.selections[label].trim();
      }
      var pk = photoProperty(label, cfg);
      var ck = characterProperty(label, cfg);
      var legacyPhotoKey = label ? label + ' - Photo' : '';
      var legacyCharKey = label ? label + ' - Character' : '';
      var pUrl = '';
      var cUrl = '';
      var cartEdit = window.builderState && window.builderState.cartEdit;
      if (cartEdit && cartEdit.preservedProps) {
        var cartProps = cartEdit.preservedProps;
        if (PB.expandCartLinePropsForEdit) {
          cartProps = PB.expandCartLinePropsForEdit(cartProps);
        } else if (PB.expandDelimiterProperties) {
          cartProps = PB.expandDelimiterProperties(cartProps);
        }
        pUrl = readCartMediaUrl(PB, cartProps, [pk, 'Photo', legacyPhotoKey, label]);
        cUrl = readCartMediaUrl(PB, cartProps, [ck, 'Character', legacyCharKey, label]);
      }
      if (existing && typeof existing === 'object' && !Array.isArray(existing)) {
        if (!pUrl) pUrl = existing[pk] || (legacyPhotoKey ? existing[legacyPhotoKey] : '') || '';
        if (!cUrl) cUrl = existing[ck] || (legacyCharKey ? existing[legacyCharKey] : '') || '';
      }
      if ((!pUrl || !cUrl) && PB.extractAiImagePropsFromSelections && window.BUILDER_DATA && window.BUILDER_DATA.mainProduct) {
        var item = window.builderState && window.builderState.mode === 'SUB' ? null : window.BUILDER_DATA.mainProduct;
        if (window.builderState && window.builderState.mode === 'SUB' && window.BUILDER_DATA.bundles) {
          var subId = window.builderState.sub && window.builderState.sub.currentId;
          var bundle = window.BUILDER_DATA.bundles.find(function (b) {
            return String(b && b.id) === String(window.builderState.bundle.selectedId || '');
          });
          if (bundle && bundle.items && subId != null) item = bundle.items[parseInt(subId, 10)] || item;
        }
        if (item) {
          var aiFlat = PB.extractAiImagePropsFromSelections(item, ctx.selections);
          if (!pUrl && pk && aiFlat[pk]) pUrl = aiFlat[pk];
          if (!pUrl && aiFlat.Photo) pUrl = aiFlat.Photo;
          if (!cUrl && ck && aiFlat[ck]) cUrl = aiFlat[ck];
          if (!cUrl && aiFlat.Character) cUrl = aiFlat.Character;
        }
      }
      if (pUrl || cUrl) {
        rehydrateWrap(wrap, { photoUrl: pUrl, characterUrl: cUrl });
      }
    }

    var retry = wrap.querySelector('.pb-ai-image-retry');
    if (retry) {
      retry.addEventListener('click', function () {
        var st = ensureState(wrap);
        if (st.isGenerating || !st.photoUrl || sessionCapHit(st)) return;
        var pending = st.pendingRequest;
        function retryRequest() {
          return pending
            ? startCharacterJob(wrap, st, pending.payload, pending.regenIdx, pending.isRevision, { skipAutoAdvance: true })
            : doGenerate(wrap, st, st.photoUrl, st.generationCount);
        }
        if (st.jobId && st.jobStatus === 'failed') {
          // Reconnect first: a lost response must never create another paid task.
          st.isGenerating = true;
          updatePreview(wrap, st);
          var existingJobId = st.jobId;
          callMediaApi('get-character-job', { jobId: existingJobId }).then(function (body) {
            if (st.jobId !== existingJobId) return;
            if (body.status === 'running' || body.status === 'queued') {
              resumeExistingInFlightJob(wrap, st, existingJobId, pending ? pending.regenIdx : st.generationCount, !!(pending && pending.isRevision));
            } else if (body.status === 'succeeded') {
              applyJobPollResult(wrap, st, body, pending ? pending.regenIdx : st.generationCount, !!(pending && pending.isRevision));
            } else if (body.resumeExisting) {
              applyGenerationFailure(wrap, st, st.requestId, new Error(body.error));
            } else {
              retryRequest();
            }
          }).catch(function (err) { applyGenerationFailure(wrap, st, st.requestId, err); });
          return;
        }
        retryRequest();
      });
    }

    bindReviseControls(wrap);

    var stFinal = ensureState(wrap);
    var innerFinal = getInnerUploadWrap(wrap);
    if (innerFinal) {
      var restoredUrls = getUploadUrls(innerFinal);
      if (restoredUrls[0] && !stFinal.photoUrl) {
        stFinal.photoUrl = restoredUrls[0];
        if (PB.renderUploadPreviews) PB.renderUploadPreviews(innerFinal, restoredUrls, 0);
      }
    }
    updatePreview(wrap, stFinal);
    syncSelections(wrap, stFinal);
  }

  function resolveAiRoot(sel) {
    if (!sel) return document;
    if (typeof sel === 'string') return document.querySelector(sel) || document;
    if (sel.nodeType === 1) return sel;
    return document;
  }

  function init(sel, options) {
    options = options || {};
    var root = resolveAiRoot(sel);
    if (!root) return;
    root.querySelectorAll('.pb-ai-image-wrap').forEach(function (wrap) {
      if (options.force) {
        wrap.removeAttribute('data-pb-ai-init');
        wrap.removeAttribute('data-pb-ai-revise-bound');
        delete wrap._pbAiOnUpload;
        delete wrap._pbAiRestoring;
        delete wrap._pbAiState;
      }
      initWrap(wrap);
    });
  }

  function validateStep(stepPage) {
    var wrap = stepPage.querySelector('.pb-ai-image-wrap');
    if (!wrap) return true;
    return resolveFieldReadiness(wrap, ensureState(wrap)).stepNavigable;
  }

  function getFieldReadiness(wrap) {
    if (!wrap) return { stepNavigable: true, finalizeReady: true, jobStatus: 'idle' };
    return resolveFieldReadiness(wrap, ensureState(wrap));
  }

  function flushWrapFromDom(wrap) {
    var state = ensureState(wrap);
    syncSelections(wrap, state);
  }

  function flushAllFromDom(sel) {
    var roots = [];
    if (typeof sel === 'string') {
      var picked = document.querySelector(sel || '#main-flow-container');
      if (picked) roots.push(picked);
    } else if (sel && sel.querySelectorAll) {
      roots.push(sel);
    }
    if (!roots.length) roots.push(document);
    ['#main-flow-container', '#sub-flow-container'].forEach(function (id) {
      var node = document.querySelector(id);
      if (node && roots.indexOf(node) === -1) roots.push(node);
    });
    var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
    roots.forEach(function (root) {
      root.querySelectorAll('.pb-ai-image-wrap').forEach(function (wrap) {
        if (seen) {
          if (seen.has(wrap)) return;
          seen.add(wrap);
        }
        flushWrapFromDom(wrap);
      });
    });
  }

  window.PBAiImage = {
    init: init,
    validateStep: validateStep,
    getFieldReadiness: getFieldReadiness,
    rehydrateWrap: rehydrateWrap,
    syncInFlightJob: syncInFlightJob,
    cancelGeneration: cancelGeneration,
    reconcileAiJobState: function (wrap) {
      reconcileAiJobState(wrap, ensureState(wrap));
    },
    flushAllFromDom: flushAllFromDom
  };

  if (!window._pbAiImageUploadCompleteListener) {
    window._pbAiImageUploadCompleteListener = true;
    document.addEventListener(
      'pb-upload-complete',
      function (e) {
        var inner = e.target;
        if (!inner || !inner.classList || !inner.classList.contains('pb-upload-wrap')) return;
        if (!inner.closest('.pb-ai-image-wrap')) return;
        var parent = inner.closest('.pb-ai-image-wrap');
        if (parent._pbAiRestoring) return;
        initWrap(parent);
        if (typeof parent._pbAiOnUpload === 'function') parent._pbAiOnUpload();
      },
      false
    );
  }

  return true;
  }

  if (!runModule()) {
    document.addEventListener('DOMContentLoaded', runModule);
    document.addEventListener('builder:ready', runModule);
  }
})();
